import { css, styled } from 'styled-components';

export const toastifyOverride = css`
  :root {
    --toastify-color-light: ${({ theme }) => theme.colors.white};
    --toastify-color-dark: ${({ theme }) => theme.colors.black};
    --toastify-color-info: ${({ theme }) => theme.colors.accent};
    --toastify-color-success: ${({ theme }) => theme.colors.green};
    --toastify-color-warning: ${({ theme }) => theme.colors.yellow};
    --toastify-color-error: ${({ theme }) => theme.colors.red};
    --toastify-icon-color-info: var(--toastify-color-info);
    --toastify-icon-color-success: var(--toastify-color-success);
    --toastify-icon-color-warning: var(--toastify-color-warning);
    --toastify-icon-color-error: var(--toastify-color-error);
    --toastify-toast-width: min(500px, 80vw);
    --toastify-font-family: ${({ theme }) => theme.fonts.Poppins};
    --toastify-text-color-light: ${({ theme }) => theme.colors.textAccent};
    --toastify-text-color-dark: ${({ theme }) => theme.colors.white};
    --toastify-toast-bottom: 5rem;
  }

  .Toastify__toast {
    font-size: 0.875rem;
    line-height: 1.4;
    gap: 0.75rem;
    text-wrap: pretty;

    a,
    button {
      font-weight: 600;
      color: ${({ theme }) => theme.colors.saturatedBlue};
      text-decoration: underline;
      cursor: pointer;
    }
  }

  .Toastify__close-button--light {
    color: ${({ theme }) => theme.colors.black};
  }

  .Toastify__toast-icon {
    width: 2.375rem;
    height: auto;

    svg {
      width: 100%;
      height: auto;
    }
  }
`;

export const ToastWrapper = styled.div`
  width: 2.375rem;
  align-items: center;
  justify-content: center;

  svg {
    width: 2.375rem;
    height: auto;
  }
`;
